<template>
    <div>
        <div class="flex mb-10">
            <div>
                <p class="text-smoke-dark text-base">Amount (NGN)</p>
                <p class="text-grey-300 text-4xl font-medium mt-4">₦ {{ data.amount | formatAmount }}</p>
            </div>
        </div>
        <div class="bg-snow-300 p-8 rounded-lg grid grid-cols-3">
            <div class="col-span-3 md:col-span-2 md:border-r border-snow-200 mb-6 md:mb-0">
                <div class="grid grid-cols-2 row-gap-12 col-gap-5">
                    <div class="col-span-1">
                        <p class="key">Account Number</p>
                        <p class="value">{{ data.account_number }}</p>
                    </div>
                    <div class="col-span-1">
                        <p class="key">Bank</p>
                        <p class="value">{{ bank.name }}</p>
                    </div>
                    <div class="col-span-1">
                        <p class="key">Account Name</p>
                        <p class="value">{{ data.account_name }}</p>
                    </div>
                    <div class="col-span-1">
                        <p class="key">Date</p>
                        <p class="value">{{ date }}</p>
                    </div>
                    <div class="col-span-1">
                        <p class="key">Remarks</p>
                        <p class="value">{{ data.reason_for_payment }}</p>
                    </div>
                    <div class="col-span-1">
                        <p class="key">Voucher</p>
                        <p class="value">{{ data.voucher || '---' }}</p>
                    </div>
                </div>
            </div>
            <div class="col-span-3 md:border-0 border-t border-snow-200 md:col-span-1 pt-6 md:pt-0 md:pl-10">
                <div class="grid grid-cols-1 gap-12">
                    <div class="col-span-1">
                        <p class="key">Transfer Fee(NGN)</p>
                        <p class="value">₦ {{ 0 | formatAmount }}</p>
                    </div>
                    <div class="col-span-1">
                        <p class="key">Email Address</p>
                        <p class="value truncate">{{ data.email }}</p>
                    </div>
                    <div class="col-span-1">
                        <p class="key">Phone Number</p>
                        <p class="value">{{ data.phone }}</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex flex-wrap md:justify-start justify-center md:items-bottom mt-8">
            <div class="md:mr-6">
                <button
                    class="text-white text-lg font-medium py-5 px-12 rounded-lg bg-orange md:w-auto w-full"
                    @click="$emit('proceed')"
                >
                    Proceed to Payment
                </button>
            </div>
            <div class="mt-6 md:mt-0">
                <button
                    class="text-orange text-lg font-medium py-5 px-12 rounded-lg bg-orange-pale md:w-auto w-full"
                    @click="$router.go(-1)"
                >
                    Edit
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { formatAmount } from '@/util/formatAmount'
import months from '@/util/months'
export default {
    filters: {
        formatAmount: function(val) {
            return formatAmount(val)
        },
    },

    computed: {
        date: function() {
            const date = new Date()

            return date.getDate() + ' ' + months[date.getMonth()] + ', ' + date.getFullYear()
        },
    },
    props: {
        data: Object,
        bank: Object,
    },
    mounted() {
        if (this.data.amount === 0) {
            this.$router.go(-1)
        }
    },
}
</script>

<style scoped lang="scss">
.key {
    color: theme('colors.smoke.100');
    font-size: 15px;
}

.value {
    color: theme('colors.grey.300');
    font-size: 15px;
    margin-top: 15px;
}
</style>
